import React, { useState, useEffect  } from 'react'
import Text from '../../atoms/text/Text'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import Icon from '../../atoms/icon/Icon'
import Image from '../../atoms/image/Image'
import InlineGroup from '../../atoms/inlinegroup/InlineGroup'
import Courtroom from '../../../assets/results/Courtroom.png'
import { thousandSeparator } from '../model/utils/formatters'
import { TeamsWithColours } from './RoundResults'

import './RoundResultsTablePage.scss'
import { useResultsContext } from './context/context'
import classNames from 'classnames'

interface Props {
  teams: TeamsWithColours[]
  data: ModelAPI.Reporting.RoyalCommissionEvent
  currencyDenomination: string
}

const RoundResultsRoyalCommission: React.FC<Props> = ({ teams, data, currencyDenomination }) => {
  const context = useResultsContext()
  const [show, setShow] = useState(context.noAnimations ? true : false)
  const [showItem, setShowItem] = useState(context.noAnimations ? true : false)

  useEffect(() => {
    let timer = setTimeout(() => setShow(true), 2000)
    if (show) {
      setTimeout(() => setShowItem(true), 2000)
    }

    return () => clearTimeout(timer)
  }, [show])

  return (
    <VerticalGroup full center wide>
      <Text size='6xl' bold colour='primaryDark' className='mb-2'>Breaking News!</Text>
      <Text size='4xl' bold center colour='blue' className='mb-6'>
        Full scale Government investigation of banking practices and processes.
      </Text>
      <InlineGroup fullHeight verticalCenter>
        <VerticalGroup full verticalCenter center style={{width: '100%', height: '100%'}}>
          <Image src={Courtroom} alt='Court Room' width='85%' className={classNames({
            'show-options': show && !context.noAnimations,
            'no-show-options': !show
          })}></Image>
        </VerticalGroup>
        <VerticalGroup full spread style={{width: '120%', height: '100%'}}>
          <Text size='3xl' bold className='mb-2'>Key Findings</Text>
          <InlineGroup className={classNames({
            'show-bids': showItem && !context.noAnimations,
            'pb-4': showItem,
            'no-show-options': !showItem
          })}>
            <Icon type='hammer' size={20} colour='primaryDark' style={{margin: 0}}></Icon>
            <VerticalGroup wide className='ml-2'>
              <Text bold size='lg' className='pb-2'>Verdict</Text>
              <Text size='lg'>Banks found to have breached responsible banking practices and had insufficient key process controls.</Text>
              <Text italic size='lg' bold className='pt-2'>"Much if not all of t he conduct identified in the first round of hearings can be traced to entites preferring pursuit of profit ti pursuit of any other purpose".</Text>
              <Text bold size='lg'>Kenneth Hayne</Text>
            </VerticalGroup>
          </InlineGroup>
          <InlineGroup className={classNames({
            'show-bids': showItem && !context.noAnimations,
            'pb-4': showItem,
            'no-show-options': !showItem
          })} style={{ animationDelay: context.noAnimations ? undefined : '1s'}}>
            <Icon type='citizens' size={20} colour='blue' style={{margin: 0}}></Icon>
            <VerticalGroup wide className='ml-2'>
              <Text bold size='lg' className='pb-2'>Good Corporate Citizens</Text>
              <Text size='lg' className='pb-4'>Some banks were found to have undertaken pro-active self-assessment of internal practices and these banks had significantly less issues relating to lending practices. These only incur {thousandSeparator(data.remediationCosts)} ({currencyDenomination}) in remediation costs and are:</Text>
              <Text size='lg' bold>
                <div className={classNames({
                  'show-bids': showItem && !context.noAnimations,
                  'pb-8': showItem,
                  'no-show-options': !showItem
                })} style={{ animationDelay: context.noAnimations ? undefined : '2s'}}>
                  {data.teams.map((teamId: number, i) => {
                    const teamList = teams.find((t) => t.teamId === teamId)

                    return (
                      <span key={i} style={{ color: `${teamList?.colour}` }}>{(i ? ', ' : '') + teamList?.teamName}</span>
                    )
                  })}
                </div>
              </Text>
            </VerticalGroup>
          </InlineGroup>
          <InlineGroup className={classNames({
            'show-bids': showItem && !context.noAnimations,
            'pb-4': showItem,
            'no-show-options': !showItem
          })} style={{ animationDelay: context.noAnimations ? undefined : '3s'}}>
            <Icon type='dollars' size={20} colour='yellow' style={{margin: 0}}></Icon>
            <VerticalGroup wide className='ml-2'>
              <Text bold size='lg' className='pb-2'>Remediation Costs</Text>
              <Text size='lg'>Banks are exposed to significant regulatory and consumer lawsuits.</Text>
              <Text bold size='lg'>Remediation costs stand at {thousandSeparator(data.costsPerBank)} ({currencyDenomination}) per bank.</Text>
            </VerticalGroup>
          </InlineGroup>
        </VerticalGroup>
      </InlineGroup>
    </VerticalGroup>
  )
}

export default RoundResultsRoyalCommission
